// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-fc16f43b] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.icon-vue[data-v-fc16f43b] {
  --icon-size: var(--298f3b4f);
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: var(--default-clickable-area);
  min-height: var(--default-clickable-area);
  opacity: 1;
}
.icon-vue--inline[data-v-fc16f43b] {
  display: inline-flex;
  min-width: fit-content;
  min-height: fit-content;
  vertical-align: text-bottom;
}
.icon-vue[data-v-fc16f43b] svg {
  fill: currentColor;
  width: var(--icon-size, 20px);
  height: var(--icon-size, 20px);
  max-width: var(--icon-size, 20px);
  max-height: var(--icon-size, 20px);
}
.icon-vue--directional[data-v-fc16f43b] svg:dir(rtl) {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcIconSvgWrapper-BiNW6Guv.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;AACpC;AACA;EACE,qBAAqB;AACvB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-fc16f43b] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.icon-vue[data-v-fc16f43b] {\n  --icon-size: var(--298f3b4f);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: var(--default-clickable-area);\n  min-height: var(--default-clickable-area);\n  opacity: 1;\n}\n.icon-vue--inline[data-v-fc16f43b] {\n  display: inline-flex;\n  min-width: fit-content;\n  min-height: fit-content;\n  vertical-align: text-bottom;\n}\n.icon-vue[data-v-fc16f43b] svg {\n  fill: currentColor;\n  width: var(--icon-size, 20px);\n  height: var(--icon-size, 20px);\n  max-width: var(--icon-size, 20px);\n  max-height: var(--icon-size, 20px);\n}\n.icon-vue--directional[data-v-fc16f43b] svg:dir(rtl) {\n  transform: scaleX(-1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
